module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeholder":"Click here, or drag an image into this field to select an image"},"da":{"placeholder":"Tryk her, eller træk et billede ind i feltet her for at vælge et billede"}}')
  delete Component.options._Ctor
}
